import env from 'environments';

/**
 * Whether the stored member data makes the member Welcome Journey eligible.
 *
 * hubspot-off-block-3 task 93: with VITE_WELCOME_JOURNEY_DISABLED on this is
 * always false, so a stale `welcomeJourneyEligible: true` left in localStorage
 * can no longer lock the sidebar, show the journey banner or switch the editor
 * into the journey flow. With the flag unset it mirrors the stored value.
 */
export const isWelcomeJourneyEligible = (userData) => {
  if (env.WELCOME_JOURNEY_DISABLED) return false;
  return Boolean(userData?.welcomeJourneyEligible);
};

export default isWelcomeJourneyEligible;
